<div class="ds-flex ds-flex-col">
  <div
    class="
      ds-rounded-lg
      ds-ml-2xl
      ds-p
      ds-max-w-[75%]
      ds-self-start
      ds-border-2
      ds-border-tertiary-lightergrey
      ds-border-dashed
      ds-w-full
      ds-center
      ds-mb-sm
    "
  >
    <div class="ds-font-bold ds-mx-auto">
      {{ message.fileName }}
    </div>
    <div class="ds-text-tertiary-mediumgrey ds-mb-xs ds-mx-auto">
      ({{ message.fileSize }}kb)
    </div>
    <button class="ds-button ds-small ds-min-h-[40px] ds-w-full ds-mx-auto">
      Ladda ner
    </button>
  </div>
</div>
